import { render, staticRenderFns } from "./StudentTopTicketArea.vue?vue&type=template&id=1fc9ca75&scoped=true&"
import script from "./StudentTopTicketArea.vue?vue&type=script&lang=js&"
export * from "./StudentTopTicketArea.vue?vue&type=script&lang=js&"
import style0 from "./StudentTopTicketArea.vue?vue&type=style&index=0&id=1fc9ca75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9ca75",
  null
  
)

export default component.exports